import template from './leave_types_component.html';
import tr from '../../lib/default-translator.js';

class AdminLeaveTypesComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.leave_types = ko.observableArray();
		this.categories = ko.observableArray();
		this.icons = ko.observableArray();
		this.filter = ko.observableArray([]);

		this.icons([
			{ 'icon': 'fas fa-umbrella-beach', 'text': '\uf5ca' },
			{ 'icon': 'fas fa-medkit', 'text': ' \uf0fa' },
			{ 'icon': 'fa fa-star', 'text': ' \uf005' },
			{ 'icon': 'fa fa-briefcase', 'text': '\uf0b1' },
			{ 'icon': 'fa fa-graduation-cap', 'text': '\uf19d' },
			{ 'icon': 'fa fa-child', 'text': '\uf1ae' }
		]);

		this.init();
	}

	async init()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'leave_category',
				limit: 1000000 
			});

			if (res.status !== 'ERROR')
				this.categories(res.records);
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_leave_types',
				limit: 1000000,
				schema: 'savanna'
			});

			if (res.status !== 'ERROR')
			{
				if (res.records != null || res.records != undefined)
					this.leave_types(res.records);
			}
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		this.updateData();
	}

	async updateData()
	{
		let filter = [];
		let category;

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_category',
			limit: 1000000
		});

		if (res.status != 'ERROR')
		{
			this.categories(res.records);
			let filtered_data = [];

			let JSONData = JSON.stringify(res.records, (key, value) => {
				filtered_data.push(value);
				return value;
			});

			let data = {
				'category': filtered_data[0].category
			};

			this.apply_filter(data);
		}

		// Check if filter is not null/undefined and apply filter
		if (this.filter().length > 0)
		{
			this.leave_types([]);
			this.filter().forEach(async(item) => {
				filter = ko.toJS(item);
				category = filter.value;

				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_leave_types',
					limit: 1000000,
					schema: 'savanna',
					filter: [{ value: category, op: '=', field: 'category' }]
				});
				if (res.records != null || res.records != undefined)
				{
					res.records.forEach(x => {
						this.leave_types.push(x)
					});
				}
			});
		}
		else
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_leave_types',
				limit: 1000000,
				schema: 'savanna'
			});

			if (res.records != null || res.records != undefined)
				this.leave_types(res.records);
		}
	};

	async edit_leave_types(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('WizardLeaveSetupOverview', data);
		this.updateData();
	};

	async add_leave_type_wizard(v, e)
	{
		await Grape.dialog.open('WizardLeaveSetupDescription', {});
		this.updateData();
	}

	async delete_leave_type(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();

		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'),
			message: tr('WARNING: You are about to completely remove a leave type. This means that leave of this type attached to employees will be deleted. THIS CANNOT BE UNDONE. Are you sure you want to delete this leave type?')
		});
			
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/leave_type/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted leave type.'), title: tr('Success') });
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	async move_down_order(v, e)
	{
		let data = ko.mapping.toJS(v);
		let res = await Grape.fetches.postJSON('/admin/leave_type/move_order_down', data);
		if (res.status !== 'ERROR')
			this.updateData();
	};

	async move_up_order(v, e)
	{
		let data = ko.mapping.toJS(v);
		let res = await Grape.fetches.postJSON('/admin/leave_type/move_order_up', data);
		if (res.status !== 'ERROR')
			this.updateData();
	};

	async archive_leave_type(v, e)
	{
		let data = ko.mapping.toJS(v);
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to archive this leave type?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/leave_type/archive', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully archived leave type.'), title: tr('Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', 	message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	apply_filter(v)
	{
		let filter = [];
		if (v.category)
			filter = {
				value: v.category,
				op: '=',
				field: 'category',
				name: 'category',
				filter_remove: false,
				value_name: v.category
			};

		// check if filter exists
		if (this.filter().length > 0)
			for (let i = 0; i < this.filter().length; i++)
			{
				if (this.filter()[i].value == filter.value && this.filter()[i].field == filter.field)
					this.filter.remove(this.filter()[i]);
			}

		if (filter != '')
		{
			this.filter.push(filter);
			this.updateData();
		}
	};

	remove_filter(v)
	{
		this.filter.remove(v);
		this.updateData();
	};
}

export default {
	name: 'leave_types_component',
	viewModel: AdminLeaveTypesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/leave_types_component'
};
